<template>
  <div id="app" :class="css">
    <NotificationBar v-if="showInfobar" v-html="$store.state.infobar.text">
    </NotificationBar>

    <Nav v-show="!showBg"></Nav>

    <Breadcrumb></Breadcrumb>

    <LicenseExceeded></LicenseExceeded>

    <router-view />

    <notifications
      class="clickable"
      group="all"
      position="bottom center"
    ></notifications>

    <Unsealer
      v-if="
        $store.state.settings.server &&
          $store.state.settings.server.sealed &&
          $store.state.settings.server.webUnsealEnabled
      "
      :value="
        $store.state.settings.server &&
          $store.state.settings.server.sealed &&
          $store.state.settings.server.webUnsealEnabled
      "
    ></Unsealer>
  </div>
</template>

<style scoped>
.full-bg {
  background-color: black;
  background-image: url("/img/background.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  /* calc(100vh - 52px); */
  overflow: hidden;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
</style>

<script>
import Nav from "@/components/main/Nav";
import Breadcrumb from "@/components/main/Breadcrumb";

export default {
  components: {
    Nav,
    Breadcrumb,
    NotificationBar: () =>
      import("@/components/main/packages/NotificationBar.vue"),
    Unsealer: () => import("@/components/main/user/Unsealer.vue"),
    LicenseExceeded: () => import("@/components/main/user/LicenseExceeded.vue"),
  },

  data() {
    return {
      showHelp: true,
    };
  },
  computed: {
    showBg() {
      return (
        this.$route.path === `/signin` ||
        this.$route.path.startsWith("/resetpassword")
      );
    },

    css() {
      return this.showBg ? "full-bg fade" : "";
    },

    showInfobar() {
      return (
        this.$store.state.infobar.package &&
        this.$route.params.computerUID &&
        this.$store.state.settings.user.profile &&
        this.$store.state.settings.user.profile.infobar &&
        this.$store.state.settings.user.profile.infobar.workingStatus
      );
    },
  },
};
</script>
